import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { ReaderData } from 'src/app/data/model/reader-data';

@Injectable({
  providedIn: 'root'
})
export class ReaderDataApiService extends CrudApiService<ReaderData> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('data/telemetries/portal-reader-data', http, config);
  }
}
